export default __webpack_public_path__ + "c892b39eaf9ea3f67b4da5307b8d0233.png";